import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { withTranslation, useTranslation } from "react-i18next";
import { usePreCheckInContext } from "./contexts/PreCheckInContext";
import moment from "moment";
import Mustache from "mustache";
import { isEmpty, get } from "lodash";
import Booking from "../../model/booking";
import Card from "./Card";
import PaymentService from "../../backend/PaymentService";

const NewCard = () => {
  const initialFormState = {
    cardholderName: "",
    cardNumber: "",
    cvcCcv: "",
    expMmYy: "",
  };

  const {
    propertyUid,
    bookingNumber,
    language,
    data: { guestService, presets, accessToken, booking, guests },
    components: { PreCheckInHeader, PreCheckInContainer },
    func: { useFormInput, setAccessTokenData, updateErrorPage },
  } = usePreCheckInContext();

  const [formData, handleFormChange] = useFormInput(initialFormState);
  const [validateForm, setValidateForm] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const history = useHistory();
  const { t } = useTranslation();
  const [currentGuest, setCurrentGuest] = useState({});

  useEffect(() => {
    if (guests && !currentGuest) {
      setCurrentGuest(guests.allGuests()[0]);

      return () => {};
    }
  }, [guests, currentGuest]);

  const addNewCard = async () => {
    setSubmitted(true);
    const validate =
      !isEmpty(formData.cardholderName) &&
      !isEmpty(formData.cardNumber) &&
      !isEmpty(formData.expMmYy);

    if (validate) {
      const expiration = formData.expMmYy.replaceAll("/", "");
      let cardData = {
        cardholderName: formData.cardholderName,
        cardNumber: formData.cardNumber.slice(formData.cardNumber.length - 4),
        expMmYy: expiration,
      };
      if (!presets.demoMode) {
        try {
          // setState({ loading: true, error: false });
          const serviceTokenData = Booking.getServiceToken(bookingNumber);
          const tokenizeData = {
            clientId: serviceTokenData.client_id,
            instanceId: serviceTokenData.instance_id,
            locationId: serviceTokenData.location_id,
            payment: {
              number: formData.cardNumber,
              expiration: expiration,
              cvv: formData.cvcCcv,
            },
          };
          const tokenizeResult = await PaymentService.postCeloTokinze(
            serviceTokenData.base_url,
            serviceTokenData.service_token,
            tokenizeData
          );
          const tokenizeResponse = tokenizeResult.data;
          if (tokenizeResponse.status === "success") {
            cardData.brand = tokenizeResponse.data.payment.brand;
            cardData.cardNumber = tokenizeResponse.data.payment.lastFour;
            // await getAccessToken(propertyUid);
            const payload = {
              brand_card: tokenizeResponse.data.payment.brand,
              token: tokenizeResponse.data.payment.token,
              email: currentGuest.email,
              node_id: guestService.core_id,
              card_holder_name: formData.cardholderName,
              expiration: formData.expMmYy.replaceAll("/", ""),
              confirmation_number: bookingNumber,
              folio_number: booking && booking.resv_id,
              booking: {
                title: currentGuest.title,
                first_name: currentGuest.firstName,
                last_name: currentGuest.lastName,
                email: currentGuest.email,
                nationality_code: currentGuest.nationalityCode,
                dob: moment.utc(currentGuest.birthday).format("YYYY-MM-DD"),
                phone: {
                  phone_number: `${currentGuest.phoneCode}${currentGuest.phone}`,
                },
                address: {
                  country_of_residence_code: currentGuest.countryCode,
                },
              },
            };
            PaymentService.postCeloPayment(accessToken, payload)
              .then((response) => {
                Booking.setPaymentTransactionID(
                  bookingNumber,
                  response.data.payment_transaction_id
                );
                Booking.setCard(bookingNumber, cardData);
                history.push(
                  `/pre-checkin/${propertyUid}/booking/${bookingNumber}/cards?language=${language}&added_card=1`
                );
              })
              .catch((error) => {
                if (get(error.response, "status") === 401) {
                  setAccessTokenData();
                }
                console.error(error);
                updateErrorPage(true);
              });
          } else {
            updateErrorPage(true);
          }
        } catch (err) {
          updateErrorPage(true);
        }
      } else {
        Booking.setCard(bookingNumber, cardData);
        history.push(
          `/pre-checkin/${propertyUid}/booking/${bookingNumber}/cards?language=${language}&added_card=1`
        );
      }
      setValidateForm(validate);
    }
  };

  return (
    <>
      <PreCheckInContainer containerName="add-credit">
        <PreCheckInHeader
          title={t("ADD_CREDIT", "ADD CREDIT")}
          headerLink
        />
        {guestService && (
          <>
            <section
              id="content"
              className="relative flex flex-col px-9 w-full flex-1 md:flex-0 pt-6">
              <p
                className="type-title xLarge mb-8 mt-6"
                style={{ color: presets.backgroundColorTopBar }}>
                {t("ADD_CREDIT", "ADD CREDIT")} /{" "}
                {t("DEBIT_CARD", "DEBIT CARD")}
              </p>
              <p className="type-regular medium mb-8 mt-6 pb-4 border-b whitespace-pre-line	">
                {Mustache.render(guestService.depositInformation, {
                  amount: "",
                })}
              </p>
              <Card
                titleColor={presets.titleColor}
                subtitleColor={presets.subtitleColor}
                backgroundColorTopBar={presets.backgroundColorTopBar}
                getCardholderName={formData.cardholderName}
                getCardNumber={formData.cardNumber}
                getCvcCcv={formData.cvcCcv}
                getExpMmYy={formData.expMmYy}
                handleChange={handleFormChange}
                validate={!submitted || (validateForm && submitted)}
              />

              <button
                className={`app-button-ipad type-title medium ${presets.buttonStyleName}`}
                style={{
                  backgroundColor: presets.backgroundColorTopBar,
                  color: presets.appHomeTextCallToAction,
                }}
                onClick={() => addNewCard()}>
                {t("CONTINUE")}
              </button>
            </section>
            <button
              className="app-button-mobile type-title medium "
              style={{
                backgroundColor: presets.backgroundColorTopBar,
                color: presets.appHomeTextCallToAction,
                position: "fixed",
                bottom: 0,
                left: 0,
              }}
              onClick={() => addNewCard()}>
              {t("CONTINUE")}
            </button>
          </>
        )}
      </PreCheckInContainer>
    </>
  );
};
export default withTranslation()(NewCard);
